<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
  >
  </cTable>
</template>

<script>
import { operBounceBack, operPostBounceBack } from "@/api/storage/BounceBack";
import cTable from "@/base/common/index.vue";
import { getAllClient } from "@/api/user/client";
export default {
  name: "bounceBack",
  components: {
    cTable
  },
  methods: {},
  data() {
    let statusList = [
      {
        label: "Wait_Picking",
        value: 0
      },
      {
        label: "BeforeOverseaWarehouse",
        value: 1
      }
    ];
    return {
      methods: {
        list: operBounceBack,
        operPostBounceBack
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = {
                airway_number: row.airway_number
              };
              this.$page
                .handleRequestMethods("operPostBounceBack", data, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 600
            },
            title: "add",
            formBind: {
              labelWidth: 80
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "airway number cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("orderNum"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 6
              },
              placeholder() {
                return this.$t("enter") + this.$t("orderNum");
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value }) {
                return value ? this.format.timeFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value }) {
                return value ? this.format.timeFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            config: {
              value: "id",
              label: "account"
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getAllClient()).data.payload.rows;
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "status",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("tip");
            },
            clearable: true,
            config: {
              label({ row }) {
                return this.$t(row.label);
              }
            },
            options: statusList
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              id: 495,
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "success"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function() {
                this.title = this.$t("add");
              });
            },
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          align: "center",
          minWidth: 150
          // component: "Button",
          // copy: true,
          // bind: {
          //   type: "primary",
          //   size: "small",
          //   style: "margin-right:10px"
          // },
          // methods: {
          //   click: ({ row }) => {
          //     let table = this.$refs["table"];
          //     table.handleRequestMethods("detail", row.id).then(res => {
          //       this.detailList = res.payload;
          //       table.getModal("detail").setTitle(row.batch_name);
          //       table.getModal("detail").open();
          //     });
          //   }
          // }
        },
        {
          name: () => this.$t("start") + this.$t("time"),
          key: "sponsor_time",
          align: "center",
          tooltip: true,
          minWidth: 130,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("out") + this.$t("time"),
          key: "operator_time",
          align: "center",
          tooltip: true,
          minWidth: 130,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("tip"),
          key: "status",
          align: "center",
          tooltip: true,
          minWidth: 100,
          methods: {
            render: ({ value }) => {
              return value ? this.$t("OutOfStock") : this.$t("ToBePicked");
            }
          }
        },
        {
          name: () => this.$t("bagNum"),
          key: "package_number",
          align: "center",
          tooltip: true,
          minWidth: 130
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          name: () => this.$t("sponsor"),
          key: "sponsor_name",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center",
          tooltip: true,
          minWidth: 100
        }
      ]
    };
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
